import styled from 'styled-components';

export const StyledContainer = styled.div`
	display: flex;
	height: inherit;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	padding: 25px 20px 15px 20px;
	width: 100%;
	font-size: 18px;
	& > .title {
		font-size: 23px;
		font-weight: bold;
		width: 100%;
		display: flex;
		justify-content: flex-start;
		color: ${({ theme }) => theme.colors.primary};
	}
	& > .actions {
		display: flex;
		justify-content: space-between;
		width: 98%;
		& > .action {
			&--primary {
				font-size: 20px;
				font-weight: bold;
				color: ${({ theme }) => theme.colors.primary};
			}
		}
		& > .action-send {
			&:hover {
				color: ${({ theme }) => theme.colors.tertiary};
			}
		}
		& > .action-cancel {
			&:hover {
				color: ${({ theme }) => theme.colors.error};
				font-weight: bold;
			}
		}
	}
`;

export const StyledLabel = styled.label`
	width: 100%;
	padding: 10px;
	background-color: ${({ theme }) => theme.colors.primary};
	color: #ffffff;
	text-align: center;
	border-radius: 3px;
	margin: 5px;
	cursor: pointer;
`;

export const StyledDeleteIcon = styled.div`
	float: right;
	margin-left: 20px;
`;

export const StyledError = styled.p`
	color: ${({ theme }) => theme.colors.error};
	font-size: 12px;
	text-align: center;
`;
export const StyledSuccess = styled.p`
	color: ${({ theme }) => theme.colors.success};
	font-size: 14px;
	text-align: center;
	font-weight: 500;
`;
export const StyledActions = styled.div`
	position: fixed;
	bottom: 10px;
`;
export const StyledContentUpload = styled.div`
	text-align: center;
`;

export const StyledText = styled.div`
	width: 100%;
	text-align: center;
	font-size: 13.5px;
	font-weight: 500;
	margin-bottom: 10px;
`;
export const StyledeFileName = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
`;
